export const AUCTION_HOUSE_CONTRACT = {
  address: "0xe468ce99444174bd3bbbed09209577d25d1ad673" as const,
  abi: [
    {
      inputs: [
        { internalType: "address", name: "_zora", type: "address" },
        { internalType: "address", name: "_weth", type: "address" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "auctionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "AuctionApprovalUpdated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "auctionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "sender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "firstBid",
          type: "bool",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "extended",
          type: "bool",
        },
      ],
      name: "AuctionBid",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "auctionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "tokenOwner",
          type: "address",
        },
      ],
      name: "AuctionCanceled",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "auctionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "duration",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "reservePrice",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "tokenOwner",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "curator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint8",
          name: "curatorFeePercentage",
          type: "uint8",
        },
        {
          indexed: false,
          internalType: "address",
          name: "auctionCurrency",
          type: "address",
        },
      ],
      name: "AuctionCreated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "auctionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "duration",
          type: "uint256",
        },
      ],
      name: "AuctionDurationExtended",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "auctionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "tokenOwner",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "curator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "winner",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "curatorFee",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "auctionCurrency",
          type: "address",
        },
      ],
      name: "AuctionEnded",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "auctionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "reservePrice",
          type: "uint256",
        },
      ],
      name: "AuctionReservePriceUpdated",
      type: "event",
    },
    { stateMutability: "payable", type: "fallback" },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "auctions",
      outputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        { internalType: "address", name: "tokenContract", type: "address" },
        { internalType: "bool", name: "approved", type: "bool" },
        { internalType: "uint256", name: "amount", type: "uint256" },
        { internalType: "uint256", name: "duration", type: "uint256" },
        { internalType: "uint256", name: "firstBidTime", type: "uint256" },
        { internalType: "uint256", name: "reservePrice", type: "uint256" },
        { internalType: "uint8", name: "curatorFeePercentage", type: "uint8" },
        { internalType: "address", name: "tokenOwner", type: "address" },
        { internalType: "address payable", name: "bidder", type: "address" },
        { internalType: "address payable", name: "curator", type: "address" },
        { internalType: "address", name: "auctionCurrency", type: "address" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "auctionId", type: "uint256" }],
      name: "cancelAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        { internalType: "address", name: "tokenContract", type: "address" },
        { internalType: "uint256", name: "duration", type: "uint256" },
        { internalType: "uint256", name: "reservePrice", type: "uint256" },
        { internalType: "address payable", name: "curator", type: "address" },
        { internalType: "uint8", name: "curatorFeePercentage", type: "uint8" },
        { internalType: "address", name: "auctionCurrency", type: "address" },
      ],
      name: "createAuction",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "auctionId", type: "uint256" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "createBid",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "auctionId", type: "uint256" }],
      name: "endAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "minBidIncrementPercentage",
      outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "auctionId", type: "uint256" },
        { internalType: "bool", name: "approved", type: "bool" },
      ],
      name: "setAuctionApproval",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "auctionId", type: "uint256" },
        { internalType: "uint256", name: "reservePrice", type: "uint256" },
      ],
      name: "setAuctionReservePrice",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "timeBuffer",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "wethAddress",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "zora",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    { stateMutability: "payable", type: "receive" },
  ] as const,
} as const;

// Media contract ABI
export const MEDIA_CONTRACT = {
  address: "0xabEFBc9fD2F806065b4f3C237d4b59D9A97Bcac7" as const,
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "marketContractAddr",
          type: "address",
        },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "_tokenId",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: false,
          internalType: "string",
          name: "_uri",
          type: "string",
        },
      ],
      name: "TokenMetadataURIUpdated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "_tokenId",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: false,
          internalType: "string",
          name: "_uri",
          type: "string",
        },
      ],
      name: "TokenURIUpdated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [],
      name: "MINT_WITH_SIG_TYPEHASH",
      outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "PERMIT_TYPEHASH",
      outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
            { internalType: "address", name: "bidder", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "sellOnShare",
              type: "tuple",
            },
          ],
          internalType: "struct IMarket.Bid",
          name: "bid",
          type: "tuple",
        },
      ],
      name: "acceptBid",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "tokenId", type: "uint256" },
      ],
      name: "approve",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        { internalType: "address", name: "recipient", type: "address" },
      ],
      name: "auctionTransfer",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "owner", type: "address" }],
      name: "balanceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "baseURI",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "getApproved",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "owner", type: "address" },
        { internalType: "address", name: "operator", type: "address" },
      ],
      name: "isApprovedForAll",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "marketContract",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "ownerOf",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "removeBid",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "removeAsk",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "revokeApproval",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "from", type: "address" },
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "tokenId", type: "uint256" },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "from", type: "address" },
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        { internalType: "bytes", name: "_data", type: "bytes" },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "operator", type: "address" },
        { internalType: "bool", name: "approved", type: "bool" },
      ],
      name: "setApprovalForAll",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "tokenURI",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "tokenMetadataURI",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "from", type: "address" },
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "tokenId", type: "uint256" },
      ],
      name: "transferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ] as const,
} as const;

// Market contract ABI
export const MARKET_CONTRACT = {
  address: "0xE5BFAB544ecA83849c53464F85B7164375Bdaac1",
  abi: [
    { inputs: [], stateMutability: "nonpayable", type: "constructor" },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
          ],
          indexed: false,
          internalType: "struct IMarket.Ask",
          name: "ask",
          type: "tuple",
        },
      ],
      name: "AskCreated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
          ],
          indexed: false,
          internalType: "struct IMarket.Ask",
          name: "ask",
          type: "tuple",
        },
      ],
      name: "AskRemoved",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
            { internalType: "address", name: "bidder", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "sellOnShare",
              type: "tuple",
            },
          ],
          indexed: false,
          internalType: "struct IMarket.Bid",
          name: "bid",
          type: "tuple",
        },
      ],
      name: "BidCreated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
            { internalType: "address", name: "bidder", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "sellOnShare",
              type: "tuple",
            },
          ],
          indexed: false,
          internalType: "struct IMarket.Bid",
          name: "bid",
          type: "tuple",
        },
      ],
      name: "BidFinalized",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
            { internalType: "address", name: "bidder", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "sellOnShare",
              type: "tuple",
            },
          ],
          indexed: false,
          internalType: "struct IMarket.Bid",
          name: "bid",
          type: "tuple",
        },
      ],
      name: "BidRemoved",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          components: [
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "prevOwner",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "creator",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "owner",
              type: "tuple",
            },
          ],
          indexed: false,
          internalType: "struct IMarket.BidShares",
          name: "bidShares",
          type: "tuple",
        },
      ],
      name: "BidShareUpdated",
      type: "event",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
            { internalType: "address", name: "bidder", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "sellOnShare",
              type: "tuple",
            },
          ],
          internalType: "struct IMarket.Bid",
          name: "expectedBid",
          type: "tuple",
        },
      ],
      name: "acceptBid",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        { internalType: "address", name: "bidder", type: "address" },
      ],
      name: "bidForTokenBidder",
      outputs: [
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
            { internalType: "address", name: "bidder", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "sellOnShare",
              type: "tuple",
            },
          ],
          internalType: "struct IMarket.Bid",
          name: "",
          type: "tuple",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "bidSharesForToken",
      outputs: [
        {
          components: [
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "prevOwner",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "creator",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "owner",
              type: "tuple",
            },
          ],
          internalType: "struct IMarket.BidShares",
          name: "",
          type: "tuple",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "mediaContractAddress",
          type: "address",
        },
      ],
      name: "configure",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "currentAskForToken",
      outputs: [
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
          ],
          internalType: "struct IMarket.Ask",
          name: "",
          type: "tuple",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        { internalType: "uint256", name: "bidAmount", type: "uint256" },
      ],
      name: "isValidBid",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "prevOwner",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "creator",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "owner",
              type: "tuple",
            },
          ],
          internalType: "struct IMarket.BidShares",
          name: "bidShares",
          type: "tuple",
        },
      ],
      name: "isValidBidShares",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "pure",
      type: "function",
    },
    {
      inputs: [],
      name: "mediaContract",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
      name: "removeAsk",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        { internalType: "address", name: "bidder", type: "address" },
      ],
      name: "removeBid",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
          ],
          internalType: "struct IMarket.Ask",
          name: "ask",
          type: "tuple",
        },
      ],
      name: "setAsk",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        {
          components: [
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "currency", type: "address" },
            { internalType: "address", name: "bidder", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "sellOnShare",
              type: "tuple",
            },
          ],
          internalType: "struct IMarket.Bid",
          name: "bid",
          type: "tuple",
        },
        { internalType: "address", name: "spender", type: "address" },
      ],
      name: "setBid",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenId", type: "uint256" },
        {
          components: [
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "prevOwner",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "creator",
              type: "tuple",
            },
            {
              components: [
                { internalType: "uint256", name: "value", type: "uint256" },
              ],
              internalType: "struct Decimal.D256",
              name: "owner",
              type: "tuple",
            },
          ],
          internalType: "struct IMarket.BidShares",
          name: "bidShares",
          type: "tuple",
        },
      ],
      name: "setBidShares",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            { internalType: "uint256", name: "value", type: "uint256" },
          ],
          internalType: "struct Decimal.D256",
          name: "sharePercentage",
          type: "tuple",
        },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "splitShare",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "pure",
      type: "function",
    },
  ] as const,
} as const;
